import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef, useContext } from 'react';
import { AccordionItemContext } from '../AccordionItem/AccordionItem.context';
import { StyledAccordionPanel } from './AccordionPanel.styles';

/**
 * Contains the content that is hidden and revealed by its sibling
 * `Accordion.Header`.
 *
 * @since 8.43.0
 */

export var AccordionPanel = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _useContext = useContext(AccordionItemContext),
    expanded = _useContext.expanded,
    panelId = _useContext.panelId,
    headerId = _useContext.headerId;
  return /*#__PURE__*/React.createElement(StyledAccordionPanel, _extends({
    ref: forwardedRef,
    "aria-labelledby": headerId,
    id: panelId,
    hidden: !expanded
  }, props));
});
AccordionPanel.displayName = 'Accordion.Panel';
AccordionPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any,
  children: PropTypes.node.isRequired,
  /**
   * A [role](https://www.w3.org/TR/wai-aria-1.2/#roles) is required for assistive
   * technologies to announce the panel properly. Panel uses the
   * [region](https://www.w3.org/TR/wai-aria-1.2/#region) role.
   */
  role: PropTypes.string
} : {};
AccordionPanel.defaultProps = {
  role: 'region'
};